// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"541c13f4","977":"3032b430"}[chunkId] + ".chunk.js";
};